const Paragraph: React.FC = ({ children }) => {
    return <p className="mb-4">{children}</p>;
  };
  
  export default Paragraph;

// vlt auch mal Lukas fragen